export type TrackingKind = "scorm" | "xapi";

export type ScormType = "SCORM_12" | "SCORM_2004";

export const TRACKING_KIND_BY_CATEGORY: Record<string, TrackingKind> = {
  DA_SCORM: "scorm",
  DA_XAPI: "xapi",
  DA_EXTERNAL_RES: "xapi",
  DA_YOUTUBE: "xapi",
  DA_LINKEDIN: "xapi",
  DA_SURVEY: "xapi",
  DA_URL_RES: "xapi",
};

export const TRACKING_EDITABLE_STATUS_KEYS: string[] = ["in-progress"];
